export function resolveOverlayTimeline(model) {
    if (!model.timeline)
        return undefined;
    const positions = model.sections.find(section => section.sectionId === model.timeline?.positionSectionId);
    const controls = model.sections.find(section => section.sectionId === model.timeline?.controlsSectionId);
    if (positions?.sectionKind !== 'select' || controls?.sectionKind !== 'actions') {
        throw new Error('Overlay timeline requires a position select and an actions section.');
    }
    const selectedIndex = positions.options.findIndex(option => option.value === positions.selectedValue);
    if (selectedIndex < 0)
        throw new Error('Overlay timeline requires a selected position.');
    return { label: model.timeline.label, positions, controls, selectedIndex };
}
export function timelinePositionIndex(fraction, count) {
    if (!Number.isFinite(fraction) || !Number.isInteger(count) || count < 1) {
        throw new Error('Timeline position requires a finite fraction and a positive position count.');
    }
    return Math.round(Math.min(1, Math.max(0, fraction)) * (count - 1));
}
export function timelineKeyboardIndex(key, current, count) {
    switch (key) {
        case 'Home': return 0;
        case 'End': return count - 1;
        case 'ArrowLeft':
        case 'ArrowDown': return Math.max(0, current - 1);
        case 'ArrowRight':
        case 'ArrowUp': return Math.min(count - 1, current + 1);
        default: return undefined;
    }
}
